import { excludeFrom, sampleRandom } from '@gametailors/web-core/misc';

export class WordToKlankConverter {
  private static readonly klanken = {
    klinkersEnkel: ['a', 'e', 'i', 'o', 'u'],
    klinkersDubbel: ['aa', 'ee', 'oo', 'uu'],
    klinkersTwee: ['ei', 'ij', 'ie', 'au', 'ou', 'oe', 'eu', 'ui', 'uw'],
    klinkersDrie: ['aai', 'ooi', 'oei', 'auw', 'ouw'],
    klinkersVier: ['eeuw', 'ieuw'],
    medeklinkers: ['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'v', 'w'],
    medeklinkersDubbel: ['bb', 'cc', 'dd', 'ff', 'gg', 'kk', 'll', 'mm', 'nn', 'pp', 'rr', 'ss', 'tt', 'zz'],
    medeklinkersSpeciaal: ['c', 'x', 'y', 'z', 'ch', 'ng', 'nk'],
    medeklinkersSjwa: ['ig', 'lijk'],
  };

  public static breakupWord(word: string): string[] {
    const klankenArray = Object.values(WordToKlankConverter.klanken).flat();
    klankenArray.sort((a, b) => b.length - a.length);
    // Regex pattern to match any klank in the word
    const pattern = new RegExp(`(${klankenArray.join('|')})`, 'g');
    // Split the word on klanken using the pattern, e.g. "fiets" => ["f", "ie", "t", "s"]
    const result = word.split(pattern).filter(Boolean);
    return result.filter((item) => item.trim() !== '');
  }

  public static getKlankVariantsFor(klank: string, max: number = Infinity, except: string[] = []): string[] {
    const homophones = [
      ['ei', 'ij'],
      ['au', 'ou'],
      ['auw', 'ouw'],
      ['d', 't'],
      ['ch', 'g'],
      ['c', 'k', 'q'],
      ['c', 's'],
    ];
    const homoPhonesToExclude = homophones.flatMap((group) => (group.includes(klank) ? group : []));

    function set(klanken: string[]): (klank: string) => string[] {
      return (klank) => (klanken.includes(klank) ? klanken : []);
    }

    // a list of functions that return an array of variants for a given klank
    const variantGroups: ((klank: string) => string[])[] = [
      set(['a', 'e', 'i', 'o', 'u']),
      (klank) => {
        const double = ['aa', 'ee', 'oo', 'uu', 'ei', 'ij', 'ie', 'au', 'ou', 'oe', 'eu', 'ui'];
        if (double.includes(klank)) return double;
        if (klank === 'uw') return ['uw', ...double];

        return [];
      },
      set(['b', 'c', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'v', 'w', 'x', 'z']),
      set(['bb', 'cc', 'dd', 'ff', 'gg', 'kk', 'll', 'mm', 'nn', 'pp', 'rr', 'ss', 'tt', 'zz']),
      set(['aai', 'ooi', 'oei', 'auw', 'ouw']),
      set(['eeuw', 'ieuw']),
      set(['ng', 'nk', 'ch']),
      set(['ig', 'lijk']),
    ];
    const illegalOptions = ['c', 'q', 'x', 'y', 'zz'];

    const group = Array.from(new Set(variantGroups.flatMap((g) => g(klank))));
    return sampleRandom(excludeFrom(group, [klank, ...except, ...homoPhonesToExclude, ...illegalOptions]), max);
  }

  public static getAllEasyKlanken(): string[] {
    return excludeFrom(
      [
        ...this.klanken.klinkersEnkel,
        ...this.klanken.klinkersDubbel,
        ...this.klanken.klinkersTwee,
        ...this.klanken.klinkersDrie,
        ...this.klanken.klinkersVier,
        ...this.klanken.medeklinkers,
        ...this.klanken.medeklinkersSpeciaal,
        ...this.klanken.medeklinkersSjwa,
      ],
      ['ig', 'lijk', 'c', 'x', 'y'],
    );
  }
}
